import httpClient from '@/http-client'

export const get = (options = {}) =>
  httpClient
    .get('/api/v1/import-tax-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))

export const store = data =>
  httpClient
    .post('/api/v1/import-tax-models', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))

export const update = (id, data) =>
  httpClient
    .put(`/api/v1/import-tax-models/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))

export default { get, store, update }
